// global
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Table, Button, Popup, Image, Icon } from 'semantic-ui-react';
import _ from 'lodash';
import { addMinutes } from 'date-fns';
// local
// lib
import t from 'app/lib/i18n';
import diffBetweenDates from 'app/lib/dateHelper';
import { formatNumber } from 'app/lib/helper';
// views
import PressureBar from './PressureBar';
import PopupCylinders from './PopupCylinders';
import PopupEditPrescription from './PopupEditPrescription';
// actions
import { addRestitution, removeRestitution, openDetail, updatePrescription, updateView, updateMapParams } from 'app/redux/actions/monitor';
// images
import ic_concentrator from 'app/_assets/img/ic_concentrator.svg';
import ic_atas_device from 'app/_assets/img/ic_atas_device.svg';
import ic_flow_alert from 'app/_assets/img/ic_flow_alert.png';
// consts
import { TYPE as CLIENT_TYPE } from 'salvus-shared/consts/client';
import { PROFILE } from 'salvus-shared/consts/account';
import { TYPE as DEVICE_TYPE } from 'salvus-shared/consts/device';

// css
import './MonitorTableRow.css';

class MonitorTableRow extends Component {
    constructor(props) {
        super(props);
        this.state = { row: props.row, onHover: false };
    }

    isSalvusUser(account) {
        if (account.client.type === CLIENT_TYPE.SALVUS && account.profile === PROFILE.DEFAULT) {
            return true;
        }
        return false;
    }

    onConfirmPrescription = value => this.props.dispatch(updatePrescription(this.state.row.id, value));

    // Handler for clicks in the plus button
    onAddClicked = e => {
        e.preventDefault();
        e.stopPropagation();
        this.props.dispatch(addRestitution(this.state.row.id));
    };

    // Handler for clicks in the minus button
    onRemoveClicked = e => {
        e.preventDefault();
        e.stopPropagation();
        this.props.dispatch(removeRestitution(this.state.row.id));
    };

    // Handler for the click in the monitor row
    onClickRow = id => () => this.props.dispatch(openDetail(id));

    // Handler for the click in the edit patient on popup edit prescription
    onEditPatient = id => this.props.dispatch(openDetail(id));

    // Handler for when the mouse enters the row
    onMouseEnter = () => this.setState({ onHover: true });

    // Handler for when the mouse leaves the row
    onMouseLeave = e => {
        // BUG: when clicking fast the mouse leave event is trigged by the child and not the parent
        if (e.target.nodeName === 'I' || e.target.nodeName === 'BUTTON' || e.currentTarget.nodeName !== 'TR') {
            return;
        }
        this.setState({ onHover: false });
    };

    // Helper fuction to check if the flwo is valid
    isFlowValid(flow, prescription) {
        if (flow === '-') {
            return true;
        }
        const percent = (prescription * 15) / 100;
        return flow > prescription - percent && flow < prescription + percent;
    }

    // Helper function to format the end time
    formatEndTime(endTime) {
        if (endTime === '-' || endTime === 0) {
            return '--';
        }
        const now = new Date();
        const end = addMinutes(now, endTime);
        return diffBetweenDates(end, now);
    }

    // Helper function to display the flow
    formatFlow(flow) {
        if (flow === '-') {
            return '--';
        }
        return formatNumber(flow);
    }

    showEndTime(endTime, expectedEndTime) {
        if (endTime === '-') {
            return this.formatEndTime(expectedEndTime);
        } else {
            return this.formatEndTime(endTime);
        }
    }

    toMap = row => e => {
        e.preventDefault();
        e.stopPropagation();

        const latitude = row.device.latitude ? row.device.latitude : row.latitude;
        const longitude = row.device.longitude ? row.device.longitude : row.longitude;
        const center = { lat: latitude, lng: longitude };
        const zoom = 15;

        this.props.dispatch(updateView('map'));

        if (latitude && longitude) this.props.dispatch(updateMapParams({ center, zoom }));
    };

    renderCylinders({ cylindersList, id, inAlert, cylinderSize, device }) {
        // if (device.type === DEVICE_TYPE.CONCENTRATOR) {
        //     return;
        // } else {
        let cylinders = [];
        _.forEach(cylindersList.slice(0, 5), function(cylinder, cindex) {
            const key = `c-${id}-${cindex}`;
            cylinders.push(<PressureBar key={key} state={cylinder.state} pressure={cylinder.pressure} inAlert={inAlert} cylinderSize={cylinderSize} />);
        });
        let otherCylinders = cylindersList.slice(5);
        if (otherCylinders.length > 0) {
            cylinders.push(<PopupCylinders key={_.uniqueId()} cylinders={otherCylinders} cylinderSize={cylinderSize} />);
        }
        return cylinders;
        // }
    }

    bateryState(batery, type) {
        switch (type) {
            case DEVICE_TYPE.CONCENTRATOR: {
                const rawCapibility = batery - 3;
                let capibility = rawCapibility <= 0 ? 0 : `${parseInt((100 * rawCapibility) / 1.2, 10)}`;
                if (capibility > 100) capibility = 100;
                return `${capibility}%`;
            }
            default: {
                let capibility =
                    batery > 3.8
                        ? 
                          parseInt(100 - (4.3 - batery) * 160, 10)
                        : batery > 3.7
                        ? parseInt(20 - (3.8 - batery) * 50, 10)
                        : parseInt(15 - (3.7 - batery) * 30, 10);

                if (capibility > 100) capibility = 100;
                else if (capibility < 0) capibility = 0;
                return `${capibility}%`;
            }
        }
    }

    render() {
        let { onHover } = this.state;
        const { row, account } = this.props;
        const clsAlert = row.isOffline && row.alertBattery ? 'crit-alert' : '';
        const className = ['table-row', clsAlert].join(' ');
        const validFlow = this.isFlowValid(row.flow, row.prescription);

        return (
            <Table.Row className={className} onMouseEnter={this.onMouseEnter} onMouseLeave={this.onMouseLeave} onClick={this.onClickRow(row.id)}>
                <Table.Cell textAlign="center" className="period-type" width="1">
                    {t(`patient_period_type_short_${row.periodType}`)}
                </Table.Cell>
                <Table.Cell width="5" className="wrap">
                    <span className="uppercase">{row.name}</span> <br />
                    <span className="patient-info">
                        <span className="bold">{row.phone1}</span>
                        {` | ${row.serviceNumber} ${row.healthInsurence}`}
                    </span>
                </Table.Cell>
                <Table.Cell textAlign="center">
                    <Button circular icon="location arrow" size="small" id={'monitor-button-device'} onClick={this.toMap(row)} />
                </Table.Cell>
                <Table.Cell textAlign="center" className="prescription" width="2">
                    {formatNumber(row.prescription)}
                </Table.Cell>
                <Table.Cell textAlign="center" className={validFlow ? 'flow' : 'flow red-label'} width="2">
                    <div className="flex flex-center">
                        {!validFlow && (
                            <Popup trigger={<Image src={ic_flow_alert} />} content="A litragem desse paciente não está de acordo com sua prescrição." />
                        )}
                        {this.formatFlow(row.flow)}
                    </div>
                </Table.Cell>
                <Table.Cell
                    textAlign="center"
                    className={row.alertEndTime ? row.endTime < 720 ? 'duration red-alert blinking' : 'duration red-alert' : row.warningEndTime ? 'duration yellow-alert' : 'duration'}
                    width="2"
                >
                    <span>
                        <div className="flex-col">
                            <div className="flex flex-center">
                                {row.alertPress && (
                                    <Popup
                                        trigger={<Image src={ic_flow_alert} />}
                                        content="Plug de pressão não está conectado. Isso pode afetar a estimativa de término."
                                    />
                                )}
                                {row.device.type === DEVICE_TYPE.CONCENTRATOR ? '--' : this.showEndTime(row.endTime, row.expectedEndTime)}
                            </div>
                        </div>
                    </span>
                </Table.Cell>
                <Table.Cell textAlign="center" className="device">
                    <div className="flex flex-space">
                        <div>
                            {row.device.type !== DEVICE_TYPE.CONCENTRATOR && <Image src={ic_atas_device} />}
                            {row.device.type === DEVICE_TYPE.CONCENTRATOR && <Image src={ic_concentrator} />}
                        </div>

                        <div className={`device-batt ${row.alertBattery || row.lowBattery === 2 ? 'red' : row.lowBattery === 1 ? 'yellow' : 'green'}`}>
                            {row.alertBattery ? (
                                <Icon name="battery zero" size="large" title={'Bateria crítica.'} />
                            ) : row.lowBattery === 2 ? (
                                <Icon name="battery low" size="large" title={'Bateria muito baixa.'} />
                            ) : row.lowBattery === 1 ? (
                                <Icon name="battery quarter" size="large" title={'Bateria baixa.'} />
                            ) : (
                                <Icon name="battery three quarters" size="large" />
                            )}
                            <span> {row.alertBattery ? 'Trocar' : this.bateryState(row.device.battery, row.device.type)} </span>
                        </div>

                        <div className={`device-signal ${row.isOffline ? 'red' : row.diffMinutes > 120 ? 'yellow' : 'green'}`}>
                            <Icon name="wifi" size="large" title={row.isOffline ? 'Dispositivo sem enviar mensagens a mais de 4 horas.' : ''} />
                            <span>
                                {' '}
                                {row.diffMinutes < 60
                                    ? row.diffMinutes + ' min'
                                    : row.diffMinutes > 60 && row.diffMinutes < 1440
                                    ? Math.round(row.diffMinutes / 60) + ' h'
                                    : Math.round(row.diffMinutes / 1440) + ' d'}
                            </span>
                        </div>
                    </div>
                </Table.Cell>
                <Table.Cell>
                    <div className="cilinders-container flex">{this.renderCylinders(row)}</div>
                </Table.Cell>
                <Table.Cell width="2">
                    {row.device.type !== DEVICE_TYPE.CONCENTRATOR && (
                        <div className="restitution-container flex">
                            {!this.isSalvusUser(account) && onHover && <Button icon="minus" onClick={this.onRemoveClicked} />}

                            <div className="restitution">{row.reposition}</div>

                            {!this.isSalvusUser(account) && onHover && <Button icon="plus" onClick={this.onAddClicked} />}
                        </div>
                    )}
                </Table.Cell>
                {!this.isSalvusUser(account) && (
                    <Table.Cell textAlign="right" width="1">
                        <PopupEditPrescription
                            dispatch={this.props.dispatch}
                            patientId={row.id}
                            // inAlert={row.inAlert}
                            prescription={row.prescription}
                            onConfirmPopup={this.onConfirmPrescription}
                            onEditPatient={this.onEditPatient}
                        />
                    </Table.Cell>
                )}
            </Table.Row>
        );
    }
}

MonitorTableRow.propTypes = {
    account: PropTypes.object,
    dispatch: PropTypes.func,
    row: PropTypes.object,
};

export default MonitorTableRow;
